// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gigNQ","footer":"styles_footer__1KCxd","passCodeTooltip":"styles_passCodeTooltip__kVFiN"};